import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.progress.dialogs.finish_retro')
};
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import ModalDialog from '@/components/ModalDialog.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'FinishRetroDialog',
    setup(__props) {
        const retroStore = useRetroStore();
        const { phase, progressModal } = storeToRefs(retroStore);
        const { next } = retroStore;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ModalDialog, {
                "primary-actions": {
                    [_ctx.$t('confirm')]: () => {
                        progressModal.value = null;
                        _unref(next)();
                    }
                },
                "secondary-actions": {
                    [_ctx.$t('cancel')]: () => {
                        progressModal.value = null;
                    }
                },
                show: _unref(phase) === 'review' && _unref(progressModal) === 'nextPhase'
            }, {
                heading: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('heading')), 1)
                ]),
                _: 1
            }, 8, ["primary-actions", "secondary-actions", "show"]));
        };
    }
});
